var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1307_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4395 26.4175L6.51477 38L1.16366 32.2536L0 5.54149L6.18368 0L20.5756 15.4555L23.7808 12.5833L28.8283 18.0039L25.6233 20.876L30 25.5761L23.8162 31.1176L19.4395 26.4175ZM14.3919 20.997L7.0282 13.0891L7.56376 27.116L14.3919 20.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5605 26.4174L41.4852 38L46.8363 32.2535L48 5.54147L41.8163 0L27.4244 15.4554L24.2192 12.5833L19.1717 18.0038L22.3767 20.876L18 25.5761L24.1838 31.1176L28.5605 26.4174ZM33.6081 20.9969L40.9718 13.0891L40.4362 27.1159L33.6081 20.9969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1307_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.73b0a64ce61fd919d5139a52b485f2d6.svg";
export { ForwardRef as ReactComponent };